module.exports = __webpack_public_path__ + "img/2.c3397615.png";